"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getDatasetProduct = void 0;
const routes_1 = require("../../routes");
const getDatasetProduct = (client) => async (productId) => {
    const response = await client.get(routes_1.ENDPOINTS.GET_ONE_DATASET_PRODUIT.applyParams(productId));
    return response.data;
};
exports.getDatasetProduct = getDatasetProduct;
